"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportError = exports.getErrorMessage = void 0;
var browser_rum_1 = require("@datadog/browser-rum");
var getErrorMessage = function (error) {
    if (error instanceof Error) {
        return error.message;
    }
    return String(error);
};
exports.getErrorMessage = getErrorMessage;
var reportError = function (_a) {
    var error = _a.error, _b = _a.context, context = _b === void 0 ? {} : _b;
    var err = (0, exports.getErrorMessage)(error);
    // report error to logging service
    try {
        browser_rum_1.datadogRum.addError(err, __assign({}, context));
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.warn('Unable to report error to logging service. ', e);
    }
};
exports.reportError = reportError;
